import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_unsecure_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Unsecure Link: This link is marked as unsecure and may contain malicious content.`;
  }
);
const de_unsecure_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Unsicherer Link: Dieser Link ist als unsicher gekennzeichnet und kann schädliche Inhalte enthalten.`;
  }
);
const sp_unsecure_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enlace no seguro: este enlace está marcado como no seguro y puede contener contenido malicioso.`;
  }
);
const unsecure_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("unsecure_link", locale);
  if (locale === "en") return en_unsecure_link();
  if (locale === "de") return de_unsecure_link();
  return sp_unsecure_link();
};
export {
  unsecure_link as u
};
